import { PolicyAmendmentProperty } from './PolicyAmendmentProperty';
import { FlatExtra } from '../customer/FlatExtra';
import { Policy } from '../customer/Policy';

export class FlatExtraAmendments {
  static fetchFlatExtrasWithPendingAmendment(policy: Policy): Array<FlatExtra> {
    const flatExtrasFromPolicy = policy.premiumBreakdown.getCurrentFlatExtras();

    if (policy.isCoverpathPolicy()) {
      let flatExtraAmendments = null;
      const property = PolicyAmendmentProperty.FLAT_EXTRA_JSON;
      const existingPCH = policy.getPendingAmendments().find((item) => item.property === property);
      if (!!existingPCH) {
        flatExtraAmendments = JSON.parse(existingPCH.newValue);
      }

      return this.getFlatExtrasWithPendingAmendment(flatExtrasFromPolicy, flatExtraAmendments);
    } else {
      return flatExtrasFromPolicy;
    }
  }

  static fetchRiderFlatExtrasWithPendingAmendment(
    policy: Policy,
    flatExtrasFromPolicy: Array<FlatExtra>,
    property: PolicyAmendmentProperty
  ): Array<FlatExtra> {
    if (!policy.isPolicyAtAmendableWorkflowStage()) {
      return flatExtrasFromPolicy;
    }

    let flatExtraAmendments = null;
    const existingPCH = policy.policyChanges.find((item) => item.property === property);

    if (!!existingPCH) {
      flatExtraAmendments = JSON.parse(existingPCH.newValue);
    }

    return this.getFlatExtrasWithPendingAmendment(flatExtrasFromPolicy, flatExtraAmendments);
  }

  private static getFlatExtrasWithPendingAmendment(flatExtrasFromPolicy, flatExtraAmendments): Array<FlatExtra> {
    let flatExtras: Array<FlatExtra> = null;
    if (flatExtrasFromPolicy) {
      if (flatExtraAmendments && flatExtraAmendments.length) {
        flatExtras = [];
        flatExtrasFromPolicy.forEach((feUwObj) => {
          const amendFe = flatExtraAmendments.find((fe) => fe.uniquePropertyValue === feUwObj.ruleCode);
          flatExtras.push(
            FlatExtra.new(
              feUwObj.name,
              feUwObj.amount,
              null,
              null,
              feUwObj.ruleCode,
              amendFe.newValue,
              feUwObj.expiryAfterInYears
            )
          );
        });

        return flatExtras;
      } else {
        return flatExtrasFromPolicy.map((fe) =>
          FlatExtra.new(fe.name, fe.amount, null, null, fe.ruleCode, fe.premium, fe.expiryAfterInYears)
        );
      }
    } else {
      return [];
    }
  }
}
